import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Home, Phone } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Heart, Squiggle, Sun, Cloud } from "../components/Illustrations";

export default function ThankYouPage() {
  useEffect(() => {
    document.title = "Ευχαριστούμε! | Ορίζοντες Ανάπτυξης";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    window.scrollTo(0, 0);
    return () => {
      document.head.removeChild(robots);
      document.title = "Ορίζοντες Ανάπτυξης | Κέντρο Ειδικών Θεραπειών στο Περιστέρι";
    };
  }, []);

  return (
    <div data-testid="thank-you-page" className="min-h-screen bg-brand-bg flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center py-24 relative overflow-hidden">
        <Sun className="absolute top-16 left-16 animate-spin-slow opacity-90 hidden md:block" size={90} />
        <Cloud className="absolute top-24 right-1/4 hidden lg:block" size={100} />
        <div className="relative max-w-xl mx-auto px-4 text-center">
          <div className="bg-white rounded-[2.5rem] p-10 sm:p-14 border-3 border-dashed border-brand-secondary -rotate-1 shadow-[0_10px_0_-3px_rgba(91,79,70,0.15)]">
            <CheckCircle2 className="mx-auto text-brand-secondary mb-5" size={64} strokeWidth={2} />
            <h1 className="font-heading font-bold text-3xl sm:text-4xl text-brand-text mb-3">
              Το μήνυμά σας{" "}
              <span className="font-hand text-4xl sm:text-5xl text-brand-primary">εστάλη!</span>
            </h1>
            <Squiggle className="mx-auto my-4" width={160} color="#FBC4D0" />
            <p className="font-body text-brand-textSoft leading-relaxed mb-8">
              Σας ευχαριστούμε πολύ που επικοινωνήσατε μαζί μας. Θα σας
              απαντήσουμε το συντομότερο δυνατό!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                data-testid="thank-you-home-button"
                to="/"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold px-7 py-3.5 border-3 border-dashed border-white shadow-[0_5px_0_-2px_rgba(91,79,70,0.25)] hover:scale-105 transition-all duration-300"
              >
                <Home size={18} strokeWidth={2.4} />
                Αρχική σελίδα
              </Link>
              <a
                data-testid="thank-you-call-button"
                href="tel:+302105719375"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-text font-heading font-bold px-7 py-3.5 border-3 border-dashed border-brand-blue hover:scale-105 transition-all duration-300"
              >
                <Phone size={18} strokeWidth={2.4} />
                210 571 9375
              </a>
            </div>
            <Heart size={26} className="mx-auto mt-8 animate-pulse-soft" color="#F4A899" />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
